import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../core/logManager";
import { resetALL } from "../../../../../.globals/redux/actions";

const INIT_STATE = {
  loading: false,
  vehicleStatusItems: [],
  total: 0,
  error: null
};

const route = "modules/manage/views/main/components/vehicleStatusTab/redux/slice.";

export const manageSearchVehicleStatuses = createAsyncThunk(
  "manage/vehicleStatusTab/manageSearchVehicleStatuses",
  async ({ openSearch }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchVehicleStatuses.query,
        {
          openSearch
        },
        endpoints.GRAPHQL_GENERAL
      );
      return response?.searchVehicleStatuses
        ? { items: response?.searchVehicleStatuses, total: response?.searchVehicleStatuses?.length }
        : { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "manageSearchVehicleStatuses");
      return rejectWithValue(exc);
    }
  }
);

manageSearchVehicleStatuses.query = `
  query searchVehicleStatuses ($openSearch: String) {
        searchVehicleStatuses (openSearch: $openSearch) {
            id
            name
            icon
            iconId
            className
        }
    }
`;

//Slice
const manageVehicleStatusTabRedux = createSlice({
  name: "manage/vehicleStatusTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageSearchVehicleStatuses
    builder.addCase(manageSearchVehicleStatuses.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageSearchVehicleStatuses.fulfilled, (state, action) => {
      state.loading = false;
      state.vehicleStatusItems = action.payload.items;
      state.total = action.payload.total;
    });
    builder.addCase(manageSearchVehicleStatuses.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageVehicleStatusTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
